import AudiencePage from "@/components/AudiencePage";

const INCLUDED = [
  ["Regular, on-time stocking", "We restock on a dependable schedule shaped by what your team actually buys — soda, water, sports drinks, chips, candy, and healthier options."],
  ["Cleaning on every visit", "Every service visit includes a full machine wipe-down and a freshness check of everything on the shelves."],
  ["Maintenance handled by us", "If the cooler, screen, or card reader ever needs attention, we take care of it — your staff never touches a tool."],
  ["Custom product selection", "The mix is built around your office. Anyone on your team can request items by scanning the QR code on the machine."],
  ["Prompt response to issues", "Call, email, or scan the QR code on the machine. A real person follows up fast, Monday–Friday, 8 AM – 8 PM."],
];

const FAQS = [
  {
    q: "What does it cost our office?",
    a: "Nothing. There is no cost to your business: we provide the smart cooler, deliver and install it, and handle all stocking, cleaning, and maintenance. Your team pays only for the items they buy.",
  },
  {
    q: "Who restocks the cooler, and how often?",
    a: "We do — on a regular schedule that we adjust based on what your location actually goes through. The cooler reports its own inventory, so we know what is running low before your team notices.",
  },
  {
    q: "Can our office choose what goes in the machine?",
    a: "Yes. The product mix is customized for your workplace — drinks, snacks, chips, candy, and healthier options. Employees can also request specific items anytime by scanning the QR code on the machine, which sends a suggestion straight to our team.",
  },
  {
    q: "What happens if the machine has a problem?",
    a: "Report it by phone, email, or the QR code on the machine and we respond promptly during service hours (Monday–Friday, 8 AM – 8 PM). The card reader, screen, and cooling system are all covered by us — never by you.",
  },
  {
    q: "How do employees pay?",
    a: "Everything is cashless. The reader on the door accepts credit and debit cards plus mobile wallets, so nobody needs to carry cash or download an app.",
  },
  {
    q: "How much space and setup does the cooler need?",
    a: "About the footprint of a standard refrigerator, plus room for the door to swing open, and a standard wall outlet nearby. We handle delivery, placement, and setup — your office just picks the spot.",
  },
];

const OfficeVending = () => (
  <AudiencePage
    testId="office-vending-page"
    overline="For Offices & Workplaces"
    h1Lines={["OFFICE VENDING WITH", "SMART COOLERS IN", "WEST CHESTER, PA."]}
    accentIndex={2}
    intro="A stocked, spotless smart cooler in your break room means lunch-hour errands disappear. Your team grabs drinks and snacks steps from their desks and stays on-site, refreshed, and working."
    howTitle="A break room that stocks itself."
    howText="We place a glass-front smart cooler in your break room or kitchen area. Your team browses through the glass, taps a card or phone on the reader, and the door unlocks — take what you want and it is charged automatically, like a walk-in store shelf. The machine reports its own inventory to us continuously, so restocks arrive before shelves run empty, tuned to what your office actually likes."
    included={INCLUDED}
    faqs={FAQS}
    imageKey="hero"
    imageAlt="Vortex smart cooler stocked with drinks and snacks for an office break room"
  />
);

export default OfficeVending;
